import React from 'react';
import styles from './IconButton.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { CircularProgress } from '@material-ui/core';

const IconButton = React.forwardRef(
  (
    {
      text,
      disable,
      onClick,
      icon,
      color,
      select,
      loading,
      size,
      active,
      style,
      border,
      textStyle,
      CustomClass,
    },
    ref
  ) => {
    const buttonstyle = () => {
      switch (size) {
        case 'mini':
          return { padding: '4px 12px 5px' };
        case 'normal':
          return { padding: '12px' };
        case 'big':
          return { padding: '6px 10px 7px' };
        case 'bigHeight':
          return { padding: '8px 12px 9px' };
        default:
          return { padding: '4px 12px 5px' };
      }
    };
    return (
      <button
        ref={ref}
        className={`${CustomClass} ${
          active ? styles.containerActive : styles.container
        } ${disable ? styles.disabled : select && styles.select}`}
        style={{
          ...buttonstyle(),
          color: disable ? '#CACFD8' : select ? 'white' : color,
          border: border,
          ...style,
        }}
        onClick={!disable ? onClick : undefined}
        disabled={disable}>
        {loading ? (
          //MUI CHANGE
          <CircularProgress size={22} />
        ) : (
          <>
            {icon && (
              <ReactSVG
                src={Icons[icon]}
                className={styles.icon}
                beforeInjection={(svg) => {
                  svg.querySelectorAll('path').forEach((path) => {
                    path.setAttribute(
                      'stroke',
                      disable ? '#CACFD8' : select ? 'white' : color
                    );
                  });
                }}
              />
            )}
            {text && (
              <span className={styles.text} style={textStyle ?? {}}>
                {text}
              </span>
            )}
          </>
        )}
      </button>
    );
  }
);

export default IconButton;
